export default __webpack_public_path__ + "static/media/dilshadansaricv.b0971635.pdf";